import BsjSetGFViewingScreenModal from './bsj-set-GF-viewing-screen-modal.vue'
export default BsjSetGFViewingScreenModal
